import { Button } from "@hireart/component-library";
import PropTypes from "prop-types";

export const ShiftFooter = ({
  isReadOnly,
  onSave,
  onClose,
  isSaving = false,
  isSaveDisabled = false,
}) => {
  return (
    <div className="flex w-full flex-col gap-8 sm:flex-row">
      {isReadOnly ? (
        <Button
          color="secondary"
          className="flex w-full items-center justify-center sm:ml-auto sm:w-auto"
          size="lg"
          type="button"
          onClick={onClose}
        >
          Close
        </Button>
      ) : (
        <div className="flex w-full flex-col gap-8 sm:flex-row sm:justify-end">
          <Button
            color="secondary"
            className="flex w-full items-center justify-center sm:w-auto"
            size="lg"
            type="button"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            color="primary-green"
            className="flex w-full items-center justify-center sm:w-auto"
            size="lg"
            type="button"
            onClick={onSave}
            isLoading={isSaving}
            isDisabled={isSaving || isSaveDisabled}
          >
            Save shift
          </Button>
        </div>
      )}
    </div>
  );
};

ShiftFooter.propTypes = {
  isReadOnly: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  isSaveDisabled: PropTypes.bool,
};
